import './index.scss';

import React from 'react';
import { useSelector } from 'react-redux';
import { useTrans } from 'core/hooks';
import OverlayComponent from './OverlayComponent';
import { selectActiveProductType } from 'core/redux/features/products/reducers/productTypes';
import { IProduct } from 'core/redux/features/products/types';
import useLanguage from 'Features/useLanguage';

interface IProps {
  product: IProduct;
}

export default function NoStockOverlayText({ product }: IProps) {
  const trans = useTrans();
  const productType = useSelector(selectActiveProductType);

  const { activeLocale } = useLanguage();

  if (product.status === 'in-stock') {
    return null;
  }

  return (
    <OverlayComponent>
      <div className="overlay__line" />
      <div className="overlay__title">
        {product
          ? trans(`overlay_title_${product?.status ?? 'showcase'}`)
          : null}
      </div>
      <p className="overlay__subtitle">
        {trans('overlay_subtitle', {
          // quick fix restaurant translation
          productType: trans('overlay_' + productType.id),
        })}
      </p>
      <div className="overlay__line" />
    </OverlayComponent>
  );
}
